import { useNavigate, useLocation } from "react-router-dom";

export const lenisRef = { current: null };

export const scrollToId = (id, offset = -72, { immediate = false } = {}) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef.current) {
    lenisRef.current.resize();
    lenisRef.current.scrollTo(el, { offset, immediate });
  } else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + offset, behavior: immediate || window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
};

export const scrollTop = (immediate = true) => {
  if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate });
  else window.scrollTo(0, 0);
};

export const useGo = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (target) => {
    if (target.startsWith("#")) {
      if (pathname === "/") scrollToId(target.slice(1));
      else navigate(`/${target}`);
      return;
    }
    navigate(target);
  };
};
